<template>
  <div
    v-if="error"
    class="flex h-screen w-full items-center justify-center"
  >
    <progress-error :error-message="error" />
  </div>
  <suspense v-else>
    <template #default>
      <layout-application>
        <template #default>
          <slot />
        </template>
      </layout-application>
    </template>
    <template #fallback>
      <loading-screen />
    </template>
  </suspense>
</template>

<script lang="ts" setup>
import { defineAsyncComponent, onErrorCaptured, ref, Ref } from 'vue'

import { getErrorDescription, ErrorType } from '@/shared/types/error-type'

const LayoutApplication = defineAsyncComponent(() => import('@/widgets/layout').then(({ LayoutApplication }) => LayoutApplication))
const LoadingScreen = defineAsyncComponent(() => import('@/shared/components/loading-screen/ui/loading-screen.vue'))
const ProgressError = defineAsyncComponent(() => import('@/shared/components/loaders/progress-error/progress-error.vue'))

const error: Ref<string> = ref('')
onErrorCaptured((err) => {
  const { message } = err
  if (message in ErrorType) {
    error.value = getErrorDescription(message as ErrorType)
  }

  return true
})
</script>
